export const arrayListCombiner = (array: Array<string | number | boolean>, lastSeperation: string = 'and'): string => {
  if (array.length < 2) {
    return array[0].toString();
  }

  return `${array.slice(0, -1).join(',')} ${lastSeperation} ${array.slice(-1)}`;
};
